<app-page-title [title]="id ? 'Alterar patrimonio' : 'Cadastrar patrimonio'"></app-page-title>
<div class="form-container">
  <form [formGroup]="form">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Descrição</mat-label>
      <input class="input" matInput placeholder="Nome" formControlName="description" />
      <mat-error *ngIf="form.controls.description.hasError('required')"> Obrigatório </mat-error>
    </mat-form-field>

    <br />

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Igreja</mat-label>
      <mat-select disableRipple formControlName="church_id" aria-readonly="true">
        <mat-option *ngFor="let church of churches" [value]="church.id">{{ church.description }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.controls.church_id.hasError('required')"> Obrigatória </mat-error>
    </mat-form-field>

    <br />

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Data de aquisição</mat-label>
      <input class="input" matInput type="date" formControlName="acquisition_date" />
      <mat-error *ngIf="form.controls.acquisition_date.hasError('required')"> Obrigatório </mat-error>
    </mat-form-field>

    <div class="type">
      <mat-label>Tipo</mat-label>
      <br />
      <mat-radio-group aria-label="Select an option" formControlName="type">
        <mat-radio-button value="Móvel">Móvel</mat-radio-button>
        <mat-radio-button value="Imóvel">Imóvel</mat-radio-button>
      </mat-radio-group>
      <mat-error *ngIf="form.controls.type.hasError('required')"> Obrigatório </mat-error>
    </div>

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Estado de conservação</mat-label>
      <mat-select disableRipple formControlName="conservation_state">
        <mat-option value="Novo">Novo</mat-option>
        <mat-option value="Bom">Bom</mat-option>
        <mat-option value="Regular">Regular</mat-option>
        <mat-option value="Ruim">Ruim</mat-option>
      </mat-select>
      <mat-error *ngIf="form.controls.conservation_state.hasError('required')"> Obrigatório </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Valor</mat-label>
      <input type="text" matInput formControlName="value" mask="separator.2" thousandSeparator="." />
      <mat-error *ngIf="form.controls.value.hasError('required')"> Obrigatório </mat-error>
    </mat-form-field>

    <br />

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Situação</mat-label>
      <mat-select disableRipple formControlName="situation">
        <mat-option value="Quitado">Quitado</mat-option>
        <mat-option value="Não quitado">Não quitado</mat-option>
      </mat-select>
      <mat-error *ngIf="form.controls.situation.hasError('required')"> Obrigatório </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" class="annotations" appearance="outline">
      <mat-label>Anotação</mat-label>
      <textarea matInput formControlName="annotations"></textarea>
    </mat-form-field>

    <br />
    <div class="container-button">
      <button (click)="add()" mat-raised-button *ngIf="!id" class="btn-primary">Cadastrar</button>
      <br />
      <button class="btn-primary" (click)="save()" mat-raised-button *ngIf="id">SALVAR</button>
      <br />
      <button class="btn-segundary" mat-raised-button [routerLink]="['/patrimonio']" type="button">Cancelar</button>
    </div>
  </form>
</div>
